const Star = ({ className, size = 18, style }) => (
  <svg viewBox="0 0 24 24" width={size} height={size} className={className} style={style} aria-hidden>
    <path d="M12 1.5 C12.8 7.5 16.5 11.2 22.5 12 C16.5 12.8 12.8 16.5 12 22.5 C11.2 16.5 7.5 12.8 1.5 12 C7.5 11.2 11.2 7.5 12 1.5 Z" fill="currentColor" />
  </svg>
);

export const HeroBackdrop = () => (
  <div aria-hidden data-testid="hero-backdrop" className="pointer-events-none absolute inset-0 -z-[2] overflow-hidden">
    <div className="hero-blob hero-blob-teal" />
    <div className="hero-blob hero-blob-yellow" />
    <div className="hero-blob hero-blob-mint" />
    <div className="hero-dots" />
    <Star size={22} className="hero-shape text-en-teal left-[7%] top-[9%] hidden sm:block" style={{ "--d": "0s" }} />
    <Star size={14} className="hero-shape text-en-yellow left-[17%] top-[14px] sm:top-[18%]" style={{ "--d": "-6s" }} />
    <Star size={16} className="hero-shape text-en-teal right-[14%] top-[8px] sm:top-[7%]" style={{ "--d": "-3s" }} />
    <Star size={26} className="hero-shape text-en-yellow right-[6%] top-[16%] hidden sm:block" style={{ "--d": "-9s" }} />
    <span className="hero-shape hero-ring left-[12%] top-[6%] h-10 w-10 border-en-teal hidden md:block" style={{ "--d": "-4s" }} />
    <span className="hero-shape hero-ring right-[9%] top-[30px] sm:top-[5%] h-6 w-6 border-en-yellow" style={{ "--d": "-11s" }} />
    <span className="hero-shape hero-ring left-[26%] top-[4%] h-3 w-3 border-black hidden lg:block" style={{ "--d": "-7s" }} />
    <span className="hero-shape hero-ring right-[24%] top-[13%] h-4 w-4 border-en-teal hidden lg:block" style={{ "--d": "-2s" }} />
  </div>
);
